import { Badge, BadgeProps } from 'antd';
import React from 'react';
import styled from 'styled-components';

const StyledBadgeCount = styled(Badge)`
  > .ant-badge-multiple-words {
    padding: 0 4px;
  }
`;

export interface IIconMenuBadgeProps extends BadgeProps {}

/**
 * Badge personalizzato per le Icone del Menu
 */
export function IconMenuBadge(props: IIconMenuBadgeProps) {
  return <StyledBadgeCount size="small" overflowCount={99} {...props} />;
}
